import DatabaseManagerStore from "./views/admin/DatabaseManager/DatabaseManagerStore";
import UIStore from "./stores/UIStore";
import SettingsStore from "stores/SettingsStore";
import ServiceViewStore from "./components/ServiceView/ServiceView.Store";

// Import store lists from each view group
import projectManagementStoreList from "./views/projectManagement/viewStoresList";
import schedulingStoreList from "./views/scheduling/schedulingStoreList";
import inventoryAndFieldStoreList from "./views/inventoryAndField/inventoryAndFieldStoreList";
import dispatchStoreList from "./views/dispatch/dispatchStoreList";
import batchPlantStoreList from "./views/batchPlant/batchPlantStoreList";
import qualityControlStoreList from "./views/qualityControl/qualityControlStoreList";
import administrationStoreList from "./views/administration/administrationStoreList";
import accountingStoreList from "./views/accounting/accountingStoreList";
import crmStoreList from "./views/crm/crmStoreList";
import productStoreList from "./views/product/productStoreList";
import purchasingStoreList from "./views/purchasing/purchasingStoreList";
import fieldReportingStoresList from "./views/fieldReporting/fieldReportingStoresList";
import pdfStoreList from "views/pdf/pdfStoreList";
import mixDesignStoreList from "./views/mixDesign/mixDesignStoreList";
import materialsStoreList from "./views/materials/materialsStoreList";
import operationsStoreList from "./views/operations/operationsStoreList";
import workflowsStoreList from "./views/workflows/workflowsStoreList";

const appStores = [
  // Core stores
  { name: "databaseManagerStore", store: DatabaseManagerStore },
  { name: "uiStore", store: UIStore },
  { name: "settingsStore", store: SettingsStore },
  { name: "serviceViewStore", store: ServiceViewStore },

  // View group stores
  ...projectManagementStoreList,
  ...schedulingStoreList,
  ...inventoryAndFieldStoreList,
  ...dispatchStoreList,
  ...batchPlantStoreList, // Renamed from production for ReadyMix
  ...qualityControlStoreList,
  ...administrationStoreList,
  ...accountingStoreList,
  ...crmStoreList,
  ...productStoreList,
  ...purchasingStoreList,
  ...fieldReportingStoresList,
  ...pdfStoreList,
  ...mixDesignStoreList, // Renamed from bom for ReadyMix
  ...materialsStoreList,
  ...operationsStoreList,
  ...workflowsStoreList
];

export default appStores;
